import React from "react";
import { formatDate } from "../season";

const Header = ({ season }) => {
  return (
    <header className=" text-white p-4" style={{ backgroundColor: "#4F1787" }}>
      <h1 className="text-center text-2xl uppercase font-bold">{season?.title || " "}</h1>
      {season?.examDate && (
        <p className="text-center text-lg uppercase font-bold">{formatDate(season.examDate)}</p>
      )}
      <p className="text-center uppercase">Student admission form</p>
    </header>
  );
};

export default Header;
